import { useState } from 'react';
import PropTypes from 'prop-types';

import { openInNewTab } from '../../../../utils/util';

import HelpCenterMenu from '../help-center-menu/HelpCenterMenu';
import Button from '../../../common/button/Button';
import TutorialModal from './tutorial-modal/TutorialModal';

import { ReactComponent as FileIcon } from '../../../../resources/icons/file.svg';
import { ReactComponent as LinkIcon } from '../../../../resources/icons/link.svg';
import { ReactComponent as EditIcon } from '../../../../resources/icons/buzz-edit.svg';
import { ReactComponent as TrashIcon } from '../../../../resources/icons/buzz-trash.svg';

import './tutorials.scss';

const Tutorials = ({ isAdmin, tutorials, createTutorial, updateTutorial, deleteTutorial, downloadDocument }) => {
  const [showModal, setShowModal] = useState(false);
  const [tutorial, setTutorial] = useState(undefined);

  const handleEditClick = (tutorial) => {
    setTutorial(tutorial);
    setShowModal(true);
  };

  const handleDeleteClick = (tutorial) => {
    deleteTutorial(tutorial.externalReference);
  };

  const handleModalClose = () => {
    setTutorial(undefined);
    setShowModal(false);
  };

  const renderLink = (link) => {
    if (!link) return null;

    if (!link.includes('youtube') && !link.includes('youtu.be')) {
      return (
        <button className="tutorials__tutorial__attachment" onClick={() => openInNewTab(link)}>
          <LinkIcon height={20} />
          {link}
        </button>
      );
    }

    let embedId;
    if (link.includes('youtube')) {
      embedId = link.split('v=')[1];
    } else if (link.includes('youtu.be')) {
      embedId = link.split('youtu.be/')[1];
    }

    return (
      <section className="tutorials__tutorial__video-container">
        <iframe
          src={`https://www.youtube.com/embed/${embedId}`}
          className="tutorials__tutorial__video"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullScreen="allowfullscreen"
        />
      </section>
    );
  };

  const renderTutorials = () => {
    return tutorials.map((tutorial) => {
      const { externalReference, tutorialDocumentVO, tutorialText, videoURLString } = tutorial;

      return (
        <section key={externalReference} className="tutorials__tutorial">
          <div className="tutorials__tutorial__text" dangerouslySetInnerHTML={{ __html: tutorialText }} />

          {isAdmin && (
            <section className="tutorials__tutorial__actions">
              <button onClick={() => handleEditClick(tutorial)}>
                <EditIcon />
              </button>
              <button onClick={() => handleDeleteClick(tutorial)}>
                <TrashIcon />
              </button>
            </section>
          )}

          {tutorialDocumentVO.name && (
            <button
              className="tutorials__tutorial__attachment"
              onClick={() => downloadDocument(tutorialDocumentVO.externalReference, tutorialDocumentVO.name)}
            >
              <FileIcon height={24} />
              {tutorialDocumentVO.name}
            </button>
          )}

          {renderLink(videoURLString)}
        </section>
      );
    });
  };

  return (
    <>
      <section className="tutorials">
        <HelpCenterMenu />

        <section className="tutorials__content">
          <section className="tutorials__header">
            <p className="tutorials__title">Tutorials</p>
          </section>

          <section className="tutorials__body">
            <section className="tutorials__tutorials">{renderTutorials()}</section>
            {isAdmin && <Button onClick={() => setShowModal(true)}>Add Tutorial</Button>}
          </section>
        </section>
      </section>

      <TutorialModal
        show={showModal}
        tutorial={tutorial}
        onClose={handleModalClose}
        createTutorial={createTutorial}
        updateTutorial={updateTutorial}
      />
    </>
  );
};

Tutorials.propTypes = {
  isAdmin: PropTypes.bool,
  tutorials: PropTypes.arrayOf(PropTypes.shape({})),
  createTutorial: PropTypes.func.isRequired,
  updateTutorial: PropTypes.func.isRequired,
  deleteTutorial: PropTypes.func.isRequired,
  downloadDocument: PropTypes.func.isRequired,
};

Tutorials.defaultProps = {
  isAdmin: false,
  tutorials: [],
};

export default Tutorials;
